var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330.1 338.3",
    style: {
      enableBackground: "new 0 0 330.1 338.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M160.1,220.2c-15,0-29-5.8-39.6-16.4c-21.8-21.8-21.8-57.4,0-79.2c10.6-10.6,24.6-16.4,39.6-16.4 c15,0,29,5.8,39.6,16.4c21.8,21.8,21.8,57.4,0,79.2C189.1,214.3,175,220.2,160.1,220.2z M160.1,113.1c-13.6,0-26.4,5.3-36.1,14.9 c-19.9,19.9-19.9,52.2,0,72.1c9.6,9.6,22.4,14.9,36.1,14.9c13.6,0,26.4-5.3,36.1-14.9c19.9-19.9,19.9-52.2,0-72.1 C186.5,118.5,173.7,113.1,160.1,113.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M223.5,230.1c-0.6,0-1.3-0.2-1.8-0.7l-25.6-25.6c-1-1-1-2.6,0-3.5c1-1,2.6-1,3.5,0l25.6,25.6c1,1,1,2.6,0,3.5 C224.8,229.9,224.2,230.1,223.5,230.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFind);
export default __webpack_public_path__ + "static/media/ico-find.266e48bce7bbfa3061fab9b6fa83e174.svg";
export { ForwardRef as ReactComponent };